<div data-test-id="filterable-hotel-list">
	@for (blok of carouselInputs(); track $index) {
		@if (carouselComponents) {
			<ndc-dynamic
				[ndcDynamicComponent]="carouselComponents[blok['component']]"
				[ndcDynamicInputs]="blok"
			/>
		}
	}
	<section class="section-spacing bg-white">
		<div class="section-inner section-gap flex-col">
			<div class="column-gap flex-col lg:flex-row">
				<div
					class="hidden flex-col lg:flex lg:w-1/4 lg:min-w-[25%] lg:max-w-[25%] lg:flex-none lg:basis-1/4"
					data-test-id="desktop"
				>
					<ng-container [ngTemplateOutlet]="hotelFilters" />
				</div>
				<div
					class="flex flex-col lg:min-w-0 lg:flex-1"
					data-test-id="content"
				>
					@for (blok of contentInputs(); track $index) {
						<div class="flex">
							@if (richTextComponents) {
								<ndc-dynamic
									[ndcDynamicComponent]="
										richTextComponents[blok['component']]
									"
									[ndcDynamicInputs]="blok"
								/>
							}
						</div>
					}
					<vp-filter-heading
						[indicator]="activeFilterCount()"
						[title]="
							(hotels().length > 1
								? 'storyblok.pages.filterable-list.title-plural'
								: 'storyblok.pages.filterable-list.title-singular'
							) | translate: { amount: hotels().length }
						"
						(sortChanged)="sortOption.set($event)"
					>
						<div data-test-id="mobile">
							<ng-container [ngTemplateOutlet]="hotelFilters" />
						</div>
					</vp-filter-heading>
					@if (sortedHotels().length > 0) {
						@for (hotel of sortedHotels(); track hotel.slug) {
							<vp-persuade-card
								[cardUrl]="baseUrl() + '/' + hotel.slug"
								[content]="hotel.content"
								[ctaText]="'global.book-directly' | translate"
								[ctaUrl]="
									hotel.availability.isBookable &&
									bookingtoolUrl + '?hotelSlug=' + hotel.slug
								"
								[images]="hotel.images"
								[overline]="hotel.countryCode"
								[price]="
									hotel.availability.isBookable && hotel.price
								"
								[pricingToolTip]="{
									occupancy: pricingTooltipOccupancy,
								}"
								[showReadMore]="true"
								[socialProof]="
									hotel.rating && {
										score: hotel.rating.score,
										numberOfRatings:
											hotel.rating.numberOfRatings,
									}
								"
								[title]="hotel.name"
							/>
						}
					} @else {
						<vp-alert
							[content]="
								'storyblok.pages.filterable-list.no-results.description'
									| translate
							"
							[emphasized]="true"
							[title]="
								'storyblok.pages.filterable-list.no-results.title'
									| translate
							"
							type="dialog--warning"
						/>
					}
				</div>
			</div>
		</div>
	</section>
</div>

<ng-template #hotelFilters>
	<vp-filters
		[activeFilters]="filterableListService.filters()"
		[filters]="filters()"
		(activeFiltersChange)="filterableListService.filters.set($event)"
	/>
</ng-template>
